import { useState, useEffect } from "react";

// screenSizeTypes.ts
export enum ScreenSize {
    Mobile = "mobile",
    Tablet = "tablet",
    Laptop = "laptop",
    Desktop = "desktop",
    LargeDesktop = "largeDesktop",
    Unknown = "unknown", // for when the screen size can't be detected
}

const useScreenSize = (): ScreenSize => {
    const breakpoints = {
        mobile: "(max-width: 599px)",
        tablet: "(min-width: 600px) and (max-width: 1019px)",
        laptop: "(min-width: 1020px) and (max-width: 1199px)",
        desktop: "(min-width: 1200px) and (max-width: 1599px)",
        largeDesktop: "(min-width: 1600px)",
    };

    const getScreenSize = (): ScreenSize => {
        if (window.matchMedia(breakpoints.largeDesktop).matches) {
            return ScreenSize.LargeDesktop;
        } else if (window.matchMedia(breakpoints.desktop).matches) {
            return ScreenSize.Desktop;
        } else if (window.matchMedia(breakpoints.laptop).matches) {
            return ScreenSize.Laptop;
        } else if (window.matchMedia(breakpoints.tablet).matches) {
            return ScreenSize.Tablet;
        } else if (window.matchMedia(breakpoints.mobile).matches) {
            return ScreenSize.Mobile;
        }
        return ScreenSize.Unknown;
    };

    const [screenSize, setScreenSize] = useState<ScreenSize>(getScreenSize());

    useEffect(() => {
        const handleResize = () => {
            setScreenSize(getScreenSize());
        };

        // Set up listeners for resize event and matchMedia
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return screenSize;
};

export default useScreenSize;